import { useEffect } from 'react';
import { useFormik } from 'formik';

import { ShippingAddressFormValues } from '../types';
import { shippingAddressValidationSchema } from '../schema';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setShippingAddressValues } from 'src/store/signup';

export const useShippingAddressForm = (
  onChange?: (isValid: boolean, dirty: boolean) => void
) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(state => state.auth?.user);

  const initialValues: ShippingAddressFormValues = {
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    streetAddress: user?.address ?? '',
    stateProvince: user?.state ?? '',
    postalCode: user?.postal ?? '',
    suburbCity: user?.city ?? '',
    mobilePhone: user?.phoneNum ?? '',
    country: 'Australia', // Default country
    addressSearch: '',
  };

  const formik = useFormik<ShippingAddressFormValues>({
    initialValues,
    validationSchema: shippingAddressValidationSchema,
    validateOnMount: true,
    validateOnChange: true,
    onSubmit: () => {}, // Parent will handle submission
  });

  const values = formik.values;
  const firstName = values?.firstName;
  const lastName = values?.lastName;

  useEffect(() => {
    dispatch(setShippingAddressValues(values));
  }, [dispatch, values]);

  useEffect(() => {
    if (user?.firstName && !formik.touched.firstName && !firstName) {
      formik.setFieldValue('firstName', user.firstName);
    }
    if (user?.lastName && !formik.touched.lastName && !lastName) {
      formik.setFieldValue('lastName', user.lastName);
    }
  }, [user?.firstName, user?.lastName, formik, firstName, lastName]);

  // Notify parent on change
  useEffect(() => {
    if (onChange) {
      onChange(formik.isValid, formik.dirty);
    }
  }, [formik.isValid, formik.dirty, onChange]);

  return formik;
};
